import { render, staticRenderFns } from "./MailingForm.vue?vue&type=template&id=0514991f&scoped=true"
import script from "./MailingForm.vue?vue&type=script&lang=js"
export * from "./MailingForm.vue?vue&type=script&lang=js"
import style0 from "./MailingForm.vue?vue&type=style&index=0&id=0514991f&prod&lang=css"
import style1 from "./MailingForm.vue?vue&type=style&index=1&id=0514991f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514991f",
  null
  
)

export default component.exports